import React, { useEffect, useState } from "react";
import { Modal, Form, Alert } from "react-bootstrap";
import { X, Loader2 } from "lucide-react";
import { createClientAsync } from "../../utils/FAR";

const AddClientModal = ({ onClose, show, onClientAdded }) => {
  const [form, setForm] = useState({
    niche: "Manufacturing",
    parent_entity: "",
    associate_enterprise: "",
    email: "",
    firstname: "",
    lastname: "",
  });

  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState(null);

  useEffect(() => {
    if (!show) {
      setForm({
        niche: "Manufacturing",
        parent_entity: "",
        associate_enterprise: "",
        email: "",
        firstname: "",
        lastname: "",
      });
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(null);
    try {
      setLoading(true);
      await createClientAsync(form);
      onClientAdded?.();
      onClose();
    } catch (err) {
      console.error(err);
      let errorMsg =
        err?.response?.data?.error ||
        err?.message ||
        "An unexpected error occurred.";
      setFormError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const requiredAsterisk = (
    <span style={{ color: "red", marginLeft: "4px" }}>*</span>
  );

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="document-upload-modal"
    >
      <Modal.Header>
        <Modal.Title>Add New Client</Modal.Title>
        <button className="close-button" onClick={onClose}>
          <X size={18} color="black" />
        </button>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label style={{ color: "black" }}>
              Niche {requiredAsterisk}
            </Form.Label>
            <Form.Control
              as="select"
              name="niche"
              value={form.niche}
              onChange={handleChange}
              required
            >
              <option value="Manufacturing">Manufacturing</option>
              <option value="Software">Software</option>
            </Form.Control>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={{ color: "black" }}>
              Parent Entity {requiredAsterisk}
            </Form.Label>
            <Form.Control
              type="text"
              name="parent_entity"
              value={form.parent_entity}
              onChange={handleChange}
              placeholder="Parent Entity"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={{ color: "black" }}>
              Associate Enterprise {requiredAsterisk}
            </Form.Label>
            <Form.Control
              type="text"
              name="associate_enterprise"
              value={form.associate_enterprise}
              onChange={handleChange}
              placeholder="Associate Enterprise"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={{ color: "black" }}>
              Email ID {requiredAsterisk}
            </Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email ID"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={{ color: "black" }}>
              First Name {requiredAsterisk}
            </Form.Label>
            <Form.Control
              type="text"
              name="firstname"
              value={form.firstname}
              onChange={handleChange}
              placeholder="First Name"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={{ color: "black" }}>
              Last Name {requiredAsterisk}
            </Form.Label>
            <Form.Control
              type="text"
              name="lastname"
              value={form.lastname}
              onChange={handleChange}
              placeholder="Last Name"
              required
            />
          </Form.Group>

          {formError && (
            <Alert variant="danger" className="mt-3">
              {formError}
            </Alert>
          )}

          <Modal.Footer className="d-flex justify-content-end gap-3">
            <button type="button" className="skip-button" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="next-button"
              disabled={loading}
              style={{ width: "120px" }}
            >
              {loading ? (
                <Loader2 size={16} className="animate-spin mr-2" />
              ) : (
                "Save"
              )}
            </button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddClientModal;
